<template>
    <div class="animated fadeIn">
        <b-row class="py-2">
            <b-card header="Editar Documento" class="w-100">
                <b-form v-if="document.type === 'EMAIL'" @submit.prevent="testEmail">
                    <b-form-group
                            label="<strong>Test email *</strong>"
                            label-for="name"
                            :horizontal="false"
                    >
                        <div class="row px-3">
                            <b-form-input id="name" class="col-9" type="text" placeholder="Email" v-model="email" required></b-form-input>
                            <button type="submit" class="btn btn-primary col-2 offset-1" :disabled="!requirementsTestEmail()">Enviar test</button>
                        </div>
                    </b-form-group>
                </b-form>
                <b-form @submit.prevent="store" enctype="multipart/form-data">
                    <b-row class="px-3">

                        <b-form-group
                            label="<strong>Nombre *</strong>"
                            label-for="name"
                            :horizontal="false" class="w-100">
                            <b-form-input id="name" type="text" placeholder="Nombre" v-model="document.name" required></b-form-input>
                        </b-form-group>

                        <b-form-group  label-for="description" label="<strong>Descripción *</strong>" class="w-100">
                            <b-form-textarea id="description"
                                             v-model="document.description"
                                             placeholder="Describa el departamento"
                                             :rows="3"
                                             :max-rows="6" :required="true">
                            </b-form-textarea>
                        </b-form-group>

                        <b-form-group
                            v-if="document.type === 'EMAIL'"
                            label="<strong>Asunto</strong>"
                            label-for="name"
                            :horizontal="false" class="w-100">
                            <b-form-input id="subject" type="text" placeholder="Asunto del email" v-model="document.subject"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="<strong>Adjuntar documentos <i class='fa fa-paperclip'></i></strong>"
                            label-for="attachments"
                            :horizontal="false"
                            class="w-100"
                            v-if="typeOfTemplate === 'email'">

                            <multiselect v-model="attachments" :options="availableAttachments" :multiple="true" track-by="uuid" label="name"></multiselect>

                            <!-- <b-button id="attachments" @click="showAvailableAttachments">
                                <i class="fa fa-paperclip mr-1"></i> Adjuntar
                            </b-button> -->

                            <!-- <b-modal
                                ref="addAttachmentsModal"
                                hide-footer
                                size="lg"
                                title="Subir Documento"
                                centered>
                                <b-form @submit.prevent="attachDocs" enctype="multipart/form-data">
                                    <b-row>
                                        <b-col offset-lg="1" lg="10">
                                            <b-form-group
                                                label="Form-checkbox-group stacked checkboxes"
                                                v-slot="{ ariaDescribedby }">
                                                <b-form-checkbox-group
                                                    v-model="selectedAttachments"
                                                    :options="options"
                                                    :aria-describedby="ariaDescribedby"
                                                    name="flavour-2a"
                                                    stacked
                                                ></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                                        <button
                                            type="submit"
                                            class="btn btn-brand btn-primary col-auto btn-lg float-right"
                                            sm="12"
                                            :disabled="!attachment">
                                            Guardar
                                        </button>
                                    </b-row>
                                </b-form>
                            </b-modal> -->
                        </b-form-group>

                        <b-form-group class="w-100 flex-wrap"
                                      label="<strong>Plantilla del documento *</html>"
                                      label-form="html">
                            <wysiwyg name="html" v-model="document.html" />
                        </b-form-group>

                    </b-row>

                    <b-row class="mx-2">
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[year]')">Año</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[total_fee]')">Total Cuotas</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[divisor]')">Divisor</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[fecha_actual]')">Fecha Actual</b-button>
                    </b-row>

                    <b-row class="mx-2">
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[nombre_socio]')">Nombre Socio</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[apellidos_socio]')">Apellidos Socio</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[dni_socio]')">DNI Socio</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[domicilio_socio]')">Domicilio Socio</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[provincia_socio]')">Provincia Socio</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[poblacion_socio]')">Población Socio</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[nombre_empresa]')">Nombre Empresa</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[cif_empresa]')">CIF Empresa</b-button>
                    </b-row>

                    <b-row class="mx-2">
                        <b-button variant="outline-success" class="mr-1 mb-2" @click="sendToText('[logo_sede]')">Logo Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[cabecera_sede]')">Cabecera Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[pie_sede]')">Pie Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[presidente_sede]')">Presidente Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[firma_presidente_sede]')">Firma Presidente Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[cargo_presidente_sede]')">Cargo Presidente Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[nombre_sede]')">Nombre Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[provincia_sede]')">Provincia Sede</b-button>
                    </b-row>

                    <b-row class="mx-2">
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[representante_sede]')">Representante Sede</b-button>
                        <b-button variant="outline-success" class="mr-1 mb-2"  @click="sendToText('[firma_de_representante_sede]')">Firma de Representante Sede</b-button>
                    </b-row>

                    <b-row>
                        <div class="col float-left">
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!requirements()"
                                v-if="mixinCheckPermission('DOCUMENT_EDIT')">
                                Guardar
                            </button>
                        </div>
                    </b-row>

                </b-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>

    import { request } from '@/helpers/services';
    import Multiselect from 'vue-multiselect';

    export default {

        name: 'addEmails',
        components: {
            Multiselect
        },
        data: function () {
            return {
                topmenu: [
                    { name: 'Volver', path: '/admin/documents/list', brand:'fa fa-arrow-left'},
                ],
                email: "",
                document:{
                    uuid: 0,
                    html: "",
                    name: "",
                    description: "",
                    type: "",
                    subject: "",
                },
                attachments: [],
                availableAttachments: [],
                typeOfTemplate: null
            }
        },

        mounted(){
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.uuid = this.$route.params.uuid;
            this.typeOfTemplate = this.$route.query.typeOfTemplate;
            this.getDocument();
            this.getAvailableAttachments();
        },

        methods: {
            async getDocument(){
                try{
                    this.$_loadingMixin_showLoading();
                    let selectedAttachments = [];
                    this.document = await request('documents/'+this.uuid,'get',200);
                    if (this.document.attachments && this.document.attachments.length) {
                        for (let i = 0; i < this.document.attachments.length; i++) {
                            selectedAttachments.push(this.document.attachments[i]['attachment']);
                        }
                    }
                    this.attachments = selectedAttachments;
                    this.$_loadingMixin_hideLoading();
                }catch(error){
                    console.log(error);
                }
            },
            async getAvailableAttachments() {
                try {
                    this.$_loadingMixin_showLoading();
                    this.availableAttachments = await request('other-attachments', 'get', 200);
                    this.$_loadingMixin_hideLoading();
                } catch (error) {
                    this.showGetErrorMsg();
                    console.log(error);
                }
            },
            async testEmail() {
                try {
                    this.$_loadingMixin_showLoading();
                    this.document = await request('documents/'+this.uuid+"/test-email",'post',200, {
                        email: this.email
                    });
                    this.$_notificationMixin_success('Operación Completada', 'Email enviado correctamente.');
                    this.$_loadingMixin_hideLoading();
                } catch(error){
                    this.$_loadingMixin_hideLoading();
                    console.log(error);
                }
            },
            async store(){
                try{
                    this.$_loadingMixin_showLoading();
                    this.document.attachments = [];
                    if (this.attachments && this.attachments.length) {
                        for (let i = 0; i < this.attachments.length; i++) {
                            if (this.attachments[i]['uuid']) {
                                this.document.attachments.push(this.attachments[i]['uuid']);
                            }
                        }
                    }
                    this.document = await request('documents/' + this.uuid, 'post', 200, this.document);
                    this.$_loadingMixin_hideLoading();
                    this.$router.push({path: '/admin/documents/list/'});

                }catch(error){
                    console.log(error);
                }
            },

            sendToText(text){
                this.document.html += " "+text+" ";
            },

            requirements(){
                if(!this.document.html || !this.document.html){
                    return false;
                }else{
                    return true;
                }
            },
            requirementsTestEmail() {
                return this.email.length;
            }
        },
    }
</script>
